import { render } from "./create_assets.html?vue&type=template&id=4d40ccb8&external"
import script from "./create_assets.js?vue&type=script&lang=js&external"
export * from "./create_assets.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__